<template>
  <div>
    <figure
      v-if="videoSource"
      ref="rootvideo"
      class="video-player mb-32"
      @mouseover="showControlBar = true"
      @mouseleave="showControlBar = false"
    >
      <!-- <figure
      v-if="videoSource"
      ref="rootvideo"
      class="video-player mb-32"
    > -->
      <!--  -->
      <div v-if="showControlBar" class="video-title">
        {{ title }}
      </div>
      <!-- Video -->
      <video ref="VideoPlayer" class="video-js" crossorigin="anonymous"></video>
      <!-- Buffering -->
      <div v-if="isLoading" class="loader-container">
        <div class="lds-spinner">
          <div v-for="loader in 12" :key="loader"></div>
        </div>
      </div>
      <!-- Control Bar -->
      <figcaption
        class="control-bar"
        :class="{
          'control-bar--show': showControlBar,
        }"
      >
        <!-- PTZ Control -->
        <div v-if="showControlBar && showPTZ">
          <div v-if="showControlBar" class="ptz-circle">
            <div v-if="showControlBar" class="video-ptzup">
              <button
                class="btn-control btn-control--ptz"
                @click="$emit('action:ptzup')"
              >
                <i class="bi bi-caret-up-fill"></i>
              </button>
            </div>
            <div v-if="showControlBar" class="video-ptzleft">
              <button
                class="btn-control btn-control--ptz"
                @click="$emit('action:ptzleft')"
              >
                <i class="bi bi-caret-left-fill"></i>
              </button>
            </div>
            <div v-if="showControlBar" class="video-ptzright">
              <button
                class="btn-control btn-control--ptz"
                @click="$emit('action:ptzright')"
              >
                <i class="bi bi-caret-right-fill"></i>
              </button>
            </div>
            <div v-if="showControlBar" class="video-ptzdown">
              <button
                class="btn-control btn-control--ptz"
                @click="$emit('action:ptzdown')"
              >
                <i class="bi bi-caret-down-fill"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Timeline -->
        <!-- <div ref="timeline" class="timeline"></div> -->
        <!-- Control buttons -->
        <div class="control-bar__left space-x-5">
          <!-- <button
            v-if="rewind"
            class="btn-control btn-control--sm"
            @click="rewindAndForward(-rewind)"
          >
            <i class="bi bi-arrow-90deg-left"></i>
            <span class="rewind-text">{{ rewind }}</span>
          </button>
          <button class="btn-control" @click="togglePlay">
            <i class="bi" :class="play ? 'bi-pause' : 'bi-play'"></i>
          </button>
          <button
            v-if="rewind"
            v-show="countSkip"
            class="btn-control btn-control--sm"
            @click="rewindAndForward(rewind)"
          >
            <i class="bi bi-arrow-90deg-right"></i>
            <span class="rewind-text">{{ rewind }}</span>
          </button>
          <button class="btn-control btn-control--md" @click="toggleAudio">
            <i
              class="bi"
              :class="muted ? 'bi-volume-mute' : 'bi-volume-up'"
            ></i>
          </button>
          <button class="btn-control btn-control--mic" @click="toggleMic">
            <i class="bi bi-mic"></i>
          </button> -->
          <div v-if="showTime" class="time-and-date">
            <!-- <span class="time">{{ clock }} WIB</span> -->
            <span class="date">{{ dateDisplay }}</span>
          </div>
        </div>
        <div class="control-bar__right space-x-5">
          <!-- <button
            class="btn-control btn-control--xs"
            :class="{ 'btn-control--active': this.vrActive }"
            @click="toggleAngle"
          >
            360&deg;
          </button> -->
          <button class="btn-control btn-control--sm" @click="toggleFullscreen">
            <i class="bi" :class="iconFullScreen"></i>
          </button>
          <!-- <div v-if="showSettings" class="settings-wrapper">
            <button
              class="btn-control btn-control--sm"
              @click.stop="toggleSetting"
            >
              <i class="bi bi-three-dots-vertical"></i>
            </button>
            <div
              ref="setting"
              class="menu-settings"
              :class="{ 'menu-settings--show': showSetting }"
            >
              <ul class="list-menu">
                <li @click="$emit('action:export')" class="list-menu__item">
                  <i class="bi bi-cloud-download-fill"></i>
                  Export
                </li>
                <li
                  v-if="!hideBookmark"
                  @click="$emit('action:bookmark')"
                  class="list-menu__item"
                >
                  <i class="bi bi-bookmark-fill"></i>
                  Bookmark
                </li>
                <li @click="$emit('action:snapshot')" class="list-menu__item">
                  <i class="bi bi-camera-fill"></i>
                  Snapshot
                </li>
                <li class="list-menu__item has-menu">
                  <i class="bi bi-gear-fill"></i>
                  Settings
                  <i class="bi bi-chevron-right icon-arrow"></i>
                  <ul class="list-menu">
                    <li class="list-menu__item has-menu">
                      Quality <i class="bi bi-chevron-right icon-arrow"></i>
                      <ul class="list-menu">
                        <li
                          class="list-menu__item"
                          :class="{
                            'list-menu__item--quality':
                              selectedQuality === 'high',
                          }"
                          @click="doSelectedQuality('high')"
                        >
                          High
                        </li>
                        <li
                          class="list-menu__item"
                          :class="{
                            'list-menu__item--quality':
                              selectedQuality === 'low',
                          }"
                          @click="doSelectedQuality('low')"
                        >
                          Low
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div> -->
        </div>
      </figcaption>
    </figure>
    <div v-if="isError" class="video-not-found">
      <div class="video-not-found__content animate-pulse">
        <span class="text-red inline-block">Video</span> not available
      </div>
    </div>
  </div>
</template>
<script>
import { GMTToLocalStringTime, padZero } from "@/composables";
import videojs from "video.js";
import "videojs-vr";
// Timeline
import { DataSet } from "vis-data/peer";
import { Timeline } from "vis-timeline/peer";
// Timeline
import "vis-timeline/styles/vis-timeline-graph2d.css";
// Videojs
import "bootstrap-icons/font/bootstrap-icons.css"; //Bootstrap Icons
import "video.js/dist/video-js.min.css";
import "@/assets/scss/player/video.scss";

export default {
  name: "VideoPlayer",
  props: {
    rewind: {
      type: Number,
      default: 0,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    isMuted: {
      type: Boolean,
      default: false,
    },
    isMicMuted: {
      type: Boolean,
      default: false,
    },
    poster: {
      type: String,
      default: null,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: null,
    },
    isPTZ: {
      type: Boolean,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "video/mp4",
    },
    resize: {
      type: [Boolean, String, Number],
      default: false,
    },
    timeStart: {
      type: [String, Number],
      required: true,
    },
    timeEnd: {
      type: [String, Number],
      default: null,
    },
    showSettings: {
      type: [Boolean, String],
      default: true,
    },
    hideBookmark: Boolean,
  },
  data: (instance) => ({
    PLAYER: null,
    play: instance.autoplay,
    muted: instance.isMuted,
    micMuted: instance.isMicMuted,
    showControlBar: false,
    showPTZ: instance.isPTZ,
    isFullscreen: false,
    interval: null,
    clock: null,
    showSetting: false,
    vrActive: false,
    showTime: true,
    isLoading: true,
    isError: false,
    selectedQuality: "low",
    retryCount: 0,
    maxRetries: 3,
    retryDelay: 1000, // ms
    loadTimeout: 15000, // 15 second timeout for loading
    timeoutHandle: null,
    config: {
      autoplay: instance.autoplay,
      poster: instance.poster,
      disablePictureInPicture: true,
      html5: {
        nativeControlsForTouch: false,
        hls: { withCredentials: false },
      },
      ...instance.options,
    },
    // Timeline
    TIMELINE: null,
    CURRENT_DATE: new Date(),
    CURRENT_TIME: new Date().getTime(),
    countSkip: 0,
  }),
  computed: {
    playerRef() {
      return this.$refs.VideoPlayer;
    },
    videoSource() {
      return this.url || null;
    },
    timelineDate() {
      return new Date(this.timeStart);
    },
    timelineEndDate() {
      return this.timeEnd && new Date(this.timeEnd);
    },
    dateDisplay() {
      const currDate = this.timelineDate;
      return currDate.toLocaleDateString("id-ID", {
        year: "numeric",
        month: "long",
        day: "numeric",
        weekday: "long",
      });
    },
    iconFullScreen() {
      return this.isFullscreen ? "bi-fullscreen-exit" : "bi-fullscreen";
    },
  },
  watch: {
    resize() {
      setTimeout(() => {
        this.detectResizeVideo();
        this.timelineBar().destroy();
        this.timelineBar().init();
      }, 300);
    },
    isFullscreen() {
      this.detectResizeVideo();
      this.timelineBar().destroy();
      this.timelineBar().init();
    },
    videoSource(val) {
      // prevent crash if player not ready or no URL yet
      if (!val || !this.PLAYER) return;

      // Reset retry count when URL changes
      this.retryCount = 0;
      this.isError = false;

      this.PLAYER.src({
        type: this.type,
        src: val,
      });

      // optional: only play if autoplay is true
      if (this.autoplay) {
        // Delay autoplay slightly to ensure source is fully loaded
        setTimeout(() => {
          this.PLAYER.play().catch(() => {});
        }, 100);
      }
    },
  },
  mounted() {
    if (this.videoSource) {
      this.initVideo();

      // this.initClock();
      this.runClock();
      this.detectResizeVideo();
      this.timelineBar().init();
      this.initMenuSettings();

      document.addEventListener("click", this.closeSetting, false);
      window.addEventListener("resize", this.detectResizeVideo, false);
    }
  },
  destroyed() {
    document.removeEventListener("click", this.closeSetting, false);
    window.removeEventListener("resize", this.detectResizeVideo, false);
  },
  methods: {
    initVideo() {
      if (this.$refs && this.playerRef) {
        const SELF = this;
        this.PLAYER = videojs(this.playerRef, this.config);

        const player = this.PLAYER;

        player.muted(this.muted);

        player.ready(() => {
          if (!SELF.videoSource) {
            SELF.isLoading = false;
            return;
          }

          player.src({
            type: SELF.type,
            src: SELF.videoSource,
          });

          // Set a timeout to fail if video doesn't load
          SELF.timeoutHandle = setTimeout(() => {
            if (SELF.isLoading) {
              console.error("Video loading timeout");
              SELF.isLoading = false;
              SELF.isError = true;
            }
          }, SELF.loadTimeout);

          player.on("loadedmetadata", () => {
            // Clear timeout on success
            if (SELF.timeoutHandle) {
              clearTimeout(SELF.timeoutHandle);
              SELF.timeoutHandle = null;
            }
            SELF.isLoading = false;
            SELF.retryCount = 0; // Reset on success
          });
        });

        player.on("error", () => {
          const error = player.error();
          console.error("Video player error:", error);

          // Clear timeout on error
          if (SELF.timeoutHandle) {
            clearTimeout(SELF.timeoutHandle);
            SELF.timeoutHandle = null;
          }

          // Don't retry on decode errors - they indicate the stream URL is invalid or has CORS issues
          // Retrying won't help and just spams errors
          SELF.isLoading = false;
          SELF.isError = true;
          
          // Emit error event so parent component can handle it
          SELF.$emit("error", error);
        });

        player.on("play", () => {
          this.play = true;
        });

        player.on("pause", () => {
          const duration = player.currentTime();
          this.play = false;
          this.$emit("pause", duration);
        });

        player.on("contextmenu", (e) => {
          e.preventDefault();
        });
        player.on("ended", () => {
          this.$emit("ended");
        });
      }
    },
    rewindAndForward(skipBy) {
      const toMilis = skipBy * 1000;
      const duration = this.timelineDate.getTime() + toMilis;
      // this for hide and show skip button forwad
      if (skipBy < 0) {
        this.countSkip -= 1;
      } else {
        this.countSkip += 1;
      }
      // save current duration
      this.$emit("skip", duration);
      // this.PLAYER.load();
    },
    togglePlay() {
      if (this.PLAYER.paused()) {
        this.PLAYER.play();
        this.play = true;
      } else {
        this.PLAYER.pause();
        this.play = false;
      }
    },
    toggleAudio() {
      if (this.PLAYER.muted()) {
        this.PLAYER.muted(false);
        this.muted = false;
      } else {
        this.PLAYER.muted(true);
        this.muted = true;
      }
    },
    toggleMic() {
      // this.micMuted = !this.micMuted;
      this.$emit("action:record");
    },
    clockWithCustomDate() {
      const initTime = new Date(GMTToLocalStringTime(this.timelineDate));
      const getTimezoneOffset =
        initTime.getTime() - initTime.getTimezoneOffset() - 3600000 * 7;

      const myTime = new Date(getTimezoneOffset);

      const diff = new Date() - this.CURRENT_DATE;

      myTime.setMilliseconds(myTime.getMilliseconds() + diff);

      const seconds = myTime.getSeconds();
      const minutes = myTime.getMinutes();
      const hours = myTime.getHours();

      this.clock = `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
    },
    runClock() {
      this.interval = setInterval(() => {
        this.clockWithCustomDate();
      }, 1000);
      this.clockWithCustomDate();
    },
    toggleFullscreen() {
      const container = this.$refs.rootvideo;
      this.isFullscreen = !this.isFullscreen;
      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (!document.mozFullScreen && !document.webkitFullScreen) {
          if (container.requestFullscreen) {
            container.requestFullscreen();
          } else if (container.mozRequestFullScreen) {
            container.mozRequestFullScreen();
          } else if (container.webkitRequestFullScreen) {
            container.webkitRequestFullScreen();
          } else if (container.msRequestFullscreen) {
            container.msRequestFullscreen();
          }
        }
      }
    },
    toggleSetting() {
      this.showSetting = !this.showSetting;
      if (!this.showSetting) {
        this.hideNestedMenu();
      }
    },
    closeSetting(e) {
      if (this.showSettings) {
        // Guard: if settings menu ref is not present (template commented out or not rendered), do nothing
        if (!this.$refs || !this.$refs.setting) return;
        if (this.$refs.setting.contains(e.target)) return;
        this.showSetting = false;
        this.hideNestedMenu();
      }
    },
    toggleAngle() {
      this.vrActive = !this.vrActive;
      if (this.vrActive) {
        this.PLAYER.vr({ projection: "360" }).init();
      } else {
        this.PLAYER.vr({ projection: "NONE" }).reset();
      }
    },
    detectResizeVideo() {
      if (this.$refs && this.$refs.rootvideo) {
        const rootVideo = this.$refs.rootvideo;
        const width = rootVideo.offsetWidth;
        if (width > 430) {
          this.showTime = true;
        } else {
          this.showTime = false;
        }
      }
    },
    initMenuSettings() {
      if (this.showSettings) {
        // Guard: if settings menu ref is not present, skip initialization
        const menu = this.$refs && this.$refs.setting;
        if (!menu) return;
        const menuItems = menu.querySelectorAll(".has-menu");

        menuItems.forEach((item) => {
          item.addEventListener("click", (e) => {
            e.stopPropagation();
            const $this = item;
            if ($this.classList.contains("list-menu__item--active")) {
              $this.classList.remove("list-menu__item--active");
            } else {
              $this.classList.add("list-menu__item--active");
            }
          });
        });
      }
    },
    hideNestedMenu() {
      // Guard: if settings menu ref is not present, nothing to hide
      const menu = this.$refs && this.$refs.setting;
      if (!menu) return;
      const menuItems = menu.querySelectorAll(".has-menu");
      menuItems.forEach((item) => {
        if (item.classList.contains("list-menu__item--active")) {
          item.classList.remove("list-menu__item--active");
        }
      });
    },
    timelineBar() {
      const init = () => {
        // Guard: if timeline ref is not present (template commented out or not rendered), skip init
        const element = this.$refs && this.$refs.timeline;
        if (!element) return;
        const date = this.timelineDate;
        const endDate = this.timelineEndDate;
        const items = new DataSet([
          {
            id: 1,
            content: this.title,
            start: date,
            end: endDate ? endDate : date,
          },
        ]);
        items.get({
          type: {
            start: "ISODate",
            end: "ISODate",
          },
        });

        const opts = {
          height: "48px",
          zoomMin: 1000 * 60 * 60,
          margin: {
            item: 0,
            axis: 0,
          },
        };
        this.TIMELINE = new Timeline(element, items, opts);
        // set current time
        this.TIMELINE.setCurrentTime(date);
        // event listener
        const SELF = this;
        // click event
        this.TIMELINE.on("click", (event) => {
          const currentTime = this.timelineEndDate || this.CURRENT_TIME;
          const currentTimeByClick = new Date(event.time).getTime();

          if (currentTimeByClick < currentTime) {
            SELF.$emit("timeline:click", currentTimeByClick);
            SELF.TIMELINE.setCurrentTime(currentTimeByClick);
            SELF.TIMELINE.moveTo(currentTimeByClick);
          }
        });
      };
      // destroy timeline
      const destroy = () => {
        if (this.TIMELINE) {
          this.TIMELINE.destroy();
          this.TIMELINE = null;
        }
      };
      return {
        init,
        destroy,
      };
    },
    doSelectedQuality(quality) {
      this.selectedQuality = quality;
      this.$emit("quality:change", quality);
    },
  },
  beforeDestroy() {
    this.CURRENT_DATE = null;
    this.CURRENT_TIME = null;
    // Clean up timeout
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
    // resetting the interval to avoid memory leaks
    if (this.PLAYER) {
      this.PLAYER.dispose();
    }
    this.timelineBar().destroy();
    // clear clock interval
    clearInterval(this.interval);
    // remove event listener
    document.removeEventListener("click", this.closeSetting);
  },
};
</script>
